import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSessionsClassicRoute: InvariantJiraRoute = {
	name: 'software-sessions-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/sessions',
	exact: true,
};
